import axios from 'axios'

class PackageRepository {
  get () {
    return axios.get(`${BASE_URL}/packages`).then((response) => {
      return response.data
    })
  }
}

export default new PackageRepository()



// WEBPACK FOOTER //
// ./src/data/package.repository.js